import { useState, useEffect } from "react";

import { Navbar, NavbarBrand, NavbarContent, NavbarItem, Button } from "@nextui-org/react";

import { Link } from "react-router-dom";

import { onAuthStateChanged } from "firebase/auth";

import { auth } from "../../../config/firebaseConfig";

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState(window.location.pathname);

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const handlePopState = () => {
      setActiveLink(window.location.pathname);
    };

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
    });

    window.addEventListener("popstate", handlePopState);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("popstate", handlePopState);

      window.removeEventListener("scroll", handleScroll);

      unsubscribeAuth();
    };
  }, []);

  const handleClick = (path: string) => {
    setActiveLink(path);
  };

  return (
    <Navbar
      isBordered={false}
      maxWidth="2xl"
      className={`
  fixed
  left-1/2
  top-3
  z-30
  h-20
  w-[95%]
  max-w-7xl
  -translate-x-1/2
  rounded-[22px]
  border-[0.1px]
  px-4
  shadow-2xl
  backdrop-blur-sm
  transition-all
  duration-500
  max-lg:hidden
  md:z-50
  md:px-2

  ${
    isScrolled
      ? `
        border-[#00CAD8]/30
        bg-gradient-to-br
        from-[#00363D]/95
        via-[#00282D]/95
        to-[#000C0F]/95
      `
      : `
       border-[#00CAD8]/20
        bg-gradient-to-br
        from-[#00363D]/85
        via-[#00282D]/85
        to-[#000C0F]/85
      `
  }
`}
    >
      {/* Logo */}
      <NavbarBrand>
        <Link to="/" onClick={() => handleClick("/")} className="flex items-center">
          <img
            src="/logo/logoblueII.svg"
            alt="Logo Miranda"
            className="
              h-14
              w-auto
              transition-all
              duration-300
              hover:scale-[1.02]
              max-md:hidden
            "
          />
        </Link>
      </NavbarBrand>

      {/* Links */}
      <NavbarContent
        justify="center"
        className="
          hidden
          gap-8
          lg:flex
        "
      >
        {[
          {
            label: "Início",
            path: "/",
          },
          {
            label: "Escritório",
            path: "/escritorio",
          },
          {
            label: "Área de atuação",
            path: "/area-atuacao",
          },
          {
            label: "Notícias",
            path: "/noticias",
          },
          {
            label: "Contato",
            path: "/contato",
          },
        ].map((item) => (
          <NavbarItem key={item.path}>
            <Link
              to={item.path}
              onClick={() => handleClick(item.path)}
              className={`
                relative
                text-sm
                font-medium
                tracking-wide
                transition-all
                duration-300

                ${activeLink === item.path ? "text-[#00CAD8]" : "text-white hover:text-[#00CAD8]"}
              `}
            >
              {item.label}

              {activeLink === item.path && (
                <span
                  className="
                    absolute
                    -bottom-2
                    left-1/2
                    h-[3px]
                    w-6
                    -translate-x-1/2
                    rounded-full
                    bg-[#00CAD8]
                  "
                />
              )}
            </Link>
          </NavbarItem>
        ))}
      </NavbarContent>

      {/* Button */}
      <NavbarContent justify="end">
        <NavbarItem>
          <Button
            as={Link}
            to={isAuthenticated ? "/dashboard" : "/login"}
            radius="full"
            variant="flat"
            className="
              hidden
              h-12
              border
              border-[#00CAD8]/20
              bg-[#00CAD8]
              px-8
              text-sm
              font-bold
              text-[#00363D]
              shadow-lg
              transition-all
              duration-300
              hover:scale-[1.03]
              hover:bg-[#11d7e6]
              lg:flex
            "
          >
            Área do cliente
          </Button>
        </NavbarItem>
      </NavbarContent>
    </Navbar>
  );
}
